module.exports = __webpack_public_path__ + "static/media/nodejs-logo.b337a2fb.svg";